import { render } from "./ContentAnnotationForm.vue?vue&type=template&id=7973e22b&scoped=true&ts=true"
import script from "./ContentAnnotationForm.vue?vue&type=script&lang=ts"
export * from "./ContentAnnotationForm.vue?vue&type=script&lang=ts"

import "./ContentAnnotationForm.vue?vue&type=style&index=0&id=7973e22b&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7973e22b"]])

export default __exports__